// extracted by mini-css-extract-plugin
export default {"button":"CancelButton_button__UDmvO"};